import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-electric-option" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "no-mb"
}
const _hoisted_5 = { style: {"font-size":"12px","font-weight":"400"} }


import { completionTwoStore } from '@/stores/completionTwo'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListElectricOption',
  props: {
    subelement: null,
    lastItem: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { subelement: { position:number, selected_option:{ externalRef:string|null, name:string, price:number, vat_rate:number }|null, disabled:boolean }, lastItem:boolean };



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      gutter: [16,16],
      class: "no-mb"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 3 }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_unref(completionTwoStore)().currentElement.position) + "." + _toDisplayString(props.subelement.position), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 21 }, {
          default: _withCtx(() => [
            (props.subelement.selected_option)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(props.subelement.selected_option.externalRef ? props.subelement.selected_option.externalRef + ' - ' : '') + _toDisplayString(props.subelement.disabled && props.subelement.selected_option.name === 'Maak een keuze..' ? '-' : props.subelement.selected_option.name), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_3, "-")),
            (props.subelement.selected_option?.externalRef)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createTextVNode("€" + _toDisplayString(props.subelement.selected_option.price.toLocaleString('nl-NL')) + " ", 1),
                  _createElementVNode("span", _hoisted_5, "incl. " + _toDisplayString(props.subelement.selected_option.vat_rate) + "% BTW", 1)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "buttons")
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    (!props.lastItem)
      ? (_openBlock(), _createBlock(_component_a_divider, {
          key: 0,
          style: { margin: '12px 0' }
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})